module.exports = __webpack_public_path__ + "static/media/calendar-week.d2f4ee3e.svg";